interface StatusTagProps {
  status: string;
  size?: "sm" | "md";
}

const styles: Record<string, string> = {
  核实中: "bg-accent-100 text-accent-900 border-accent-300",
  已更新: "bg-secondary-100 text-secondary-900 border-secondary-300",
  已归档: "bg-background-200 text-foreground-700 border-background-300",
};

function StatusTag({ status, size = "sm" }: StatusTagProps) {
  const style = styles[status] || "bg-background-200 text-foreground-700 border-background-300";
  const sizing = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-3 py-1 text-xs";

  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border font-label font-medium ${style} ${sizing}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}

export default StatusTag;